// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map[data-v-b0232d68] {\n  flex-grow: 1;\n  height: calc(100vh - 240px);\n  border: 1px solid transparent;\n  border-radius: 4px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n[data-v-b0232d68] .leaflet-popup {\n  margin-bottom: 50px !important;\n}", ""]);
// Exports
module.exports = exports;
